/* quote-modal.js — opener + validator + estimate + Web3Forms email */
(function () {
  const SUPPORT_PHONE = '484.212.6363';
  let CLOSE_GLOBAL_WIRED = false; // guard for global close handlers

  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function moveToBody(el) {
    try { if (el && el.parentNode !== document.body) document.body.appendChild(el); } catch(_) {}
  }
  function openModal(modal) {
    if (!modal) return;
    moveToBody(modal);
    modal.style.display = 'flex';
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    try { $('.quote-close', modal)?.focus({ preventScroll: true }); } catch(_) {}
  }
  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    modal.style.display = 'none';
  }
  function wireCloseHandlers(modal) {
    if (!modal || modal.__wiredClose) return;
    modal.__wiredClose = true;
    $('.quote-backdrop', modal)?.addEventListener('click', () => closeModal(modal));
    $$('[data-qm-close], [data-qme-close], .quote-close', modal).forEach(el => {
      el.addEventListener('click', e => { e.preventDefault(); closeModal(modal); });
    });
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal(modal);
    });
  }

  // Refresh read-only SKU and price/sqft from product page DOM
  function refreshReadOnlyFields(modal) {
    try {
      const skuEl   = document.querySelector('[id^="Sku-"], [data-product-sku], .product-sku');
      const sku     = skuEl ? skuEl.textContent.trim() : '';
      const priceEl = document.querySelector('.price-item.price-item--regular');
      const priceText = priceEl ? priceEl.textContent : '';
      const priceNum  = parseFloat((priceText || '').replace(/[^\d.]/g, '')) || 0;

      $('#qm-productSKU', modal)?.setAttribute('value', sku || '');
      const roSKU = $('#qm-ro-productSKU', modal); if (roSKU) roSKU.textContent = sku || 'N/A';

      $('#qm-pricePerSqft', modal)?.setAttribute('value', String(priceNum));
      const roPPS = $('#qm-ro-pricePerSqft', modal); if (roPPS) roPPS.textContent = priceNum ? `$${priceNum}` : '$0';
    } catch(_) {}
  }

  // ========== Validation ==========
  const isEmail  = v => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(v || '').trim());
  const isPhone10 = v => String(v || '').replace(/[^\d]/g, '').length >= 10;
  const isPositiveNumber = v => Number.isFinite(+v) && +v > 0;

  function setError(input, msg) {
    if (!input) return;
    let msgEl = input.parentElement.querySelector('.qm-error');
    if (!msgEl) {
      msgEl = document.createElement('div');
      msgEl.className = 'qm-error';
      msgEl.style.cssText = 'color:#b91c1c;font-size:12px;margin-top:4px;';
      input.parentElement.appendChild(msgEl);
    }
    msgEl.textContent = msg;
    input.setAttribute('aria-invalid', 'true');
    input.style.borderColor = '#fca5a5';
    input.style.boxShadow = '0 0 0 3px rgba(239,68,68,.15)';
  }
  function clearError(input) {
    if (!input) return;
    input.removeAttribute('aria-invalid');
    input.style.borderColor = '';
    input.style.boxShadow = '';
    input.parentElement.querySelector('.qm-error')?.remove();
  }

  // ========== Phone mask (xxx)-xxx-xxxx ==========
  function fmtPhone(raw) {
    const d = (raw || '').replace(/\D/g, '').slice(0, 10);
    const L = d.length;
    if (!L) return '';
    if (L < 4) return `(${d}`;
    if (L < 7) return `(${d.slice(0,3)})-${d.slice(3)}`;
    return `(${d.slice(0,3)})-${d.slice(3,6)}-${d.slice(6)}`;
  }
  function wirePhoneMask(input) {
    if (!input || input.__masked) return;
    input.__masked = true;
    input.addEventListener('input', () => {
      const atEnd = input.selectionStart === input.value.length;
      input.value = fmtPhone(input.value);
      if (atEnd) input.selectionStart = input.selectionEnd = input.value.length;
    });
    input.addEventListener('paste', () => setTimeout(() => { input.value = fmtPhone(input.value); }));
    input.addEventListener('blur',  () => { input.value = fmtPhone(input.value); });
  }

  // ========== UI banner (inline notice on the form) ==========
  function showFormBanner(form, type, text) {
    let bar = form.querySelector('.qm-banner');
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'qm-banner';
      bar.style.cssText = 'grid-column:1/-1;margin-top:8px;padding:10px 12px;border-radius:10px;font-size:14px;';
      form.appendChild(bar);
    }
    if (type === 'error') {
      bar.style.background = '#fee2e2';
      bar.style.border = '1px solid #fecaca';
      bar.style.color = '#991b1b';
    } else if (type === 'success') {
      bar.style.background = '#dcfce7';
      bar.style.border = '1px solid #bbf7d0';
      bar.style.color = '#166534';
    } else {
      bar.style.background = '#e5e7eb';
      bar.style.border = '1px solid #d1d5db';
      bar.style.color = '#111827';
    }
    bar.textContent = text;
  }

  // ========== Web3Forms send (returns true/false) ==========
  async function sendWeb3FormsEmail({ modal, estimate, breakdown }) {
    const name  = $('#qm-name', modal)?.value?.trim()  || '';
    const email = $('#qm-email', modal)?.value?.trim() || '';
    const addr  = $('#qm-address', modal)?.value?.trim() || '';
    const note  = $('#qm-comment', modal)?.value?.trim() || '';
    const phone = $('#qm-phone', modal)?.value?.trim() || '';
    const ext   = $('#qm-phone-ext', modal)?.value?.trim() || '';

    const phoneCombined = phone && ext ? `${phone} x${ext}` : phone;

    const product   = $('#qm-productName', modal)?.value || '';
    const sku       = $('#qm-productSKU', modal)?.value || '';
    const pps       = parseFloat($('#qm-pricePerSqft', modal)?.value || '0');

    const key = window.WEB3FORMS_KEY || '';
    if (!key) {
      console.warn('[QM] Missing Web3Forms key. Set window.WEB3FORMS_KEY in theme.liquid.');
      return false;
    }

    const message = `
Quote Request
---------------
Product: ${product}
SKU: ${sku}
Price per sqft: $${pps.toFixed(2)}

Inputs
${breakdown.inputs}

Breakdown
${breakdown.lines}

Estimated Total
${estimate}

Customer
Name: ${name || 'N/A'}
Email: ${email || 'N/A'}
Phone: ${phoneCombined || 'N/A'}
Address: ${addr || 'N/A'}

Comments
${note || 'N/A'}
`.trim();

    const payload = {
      access_key: key,
      subject: `New Quote Request ${name ? 'from ' + name : ''}`,
      from_name: name || 'Website Visitor',
      from_email: email || 'no-reply@yourdomain.com',
      replyto: email || undefined,
      phone: phoneCombined,
      page_url: location.href,
      message
    };

    try {
      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload)
      });
      const json = await res.json();
      if (!json.success) {
        console.warn('[QM] Web3Forms returned an error:', json);
        return false;
      }
      return true;
    } catch (err) {
      console.error('[QM] Web3Forms network error:', err);
      return false;
    }
  }

  // ========== Compute & render ==========
  function computeEstimate(modal) {
    const price = parseFloat($('#qm-pricePerSqft', modal)?.value || '0');
    const sqft  = parseFloat($('#qm-sqft', modal)?.value || '0');
    const cuts  = parseInt($('#qm-cutouts', modal)?.value || '0', 10);
    const edge  = $('#qm-edgeType', modal)?.value || '';

    let edgeExtra = 0;
    if (edge === 'Beveled') edgeExtra = 5;
    if (edge === 'Ogee')    edgeExtra = 10;

    const material = price * sqft;
    const cutCost  = (Number.isFinite(cuts) ? cuts : 0) * 5;
    const edgeCost = edgeExtra * sqft;
    const total    = (material || 0) + (cutCost || 0) + (edgeCost || 0);

    return { price, sqft, cuts, edge, edgeExtra, material, cutCost, edgeCost, total };
  }

  function fillEstimateModal(estModal, calc) {
    const totalEl = $('#qme-total-amount', estModal);
    if (totalEl) totalEl.textContent = `$${(calc.total || 0).toFixed(2)}`;

    const linePrice  = $('#qme-line-price', estModal);
    const lineCuts   = $('#qme-line-cutouts', estModal);
    const lineEdge   = $('#qme-line-edge', estModal);

    if (linePrice) linePrice.innerHTML = `Material: $${(calc.price || 0).toFixed(2)} × <strong>${Number.isFinite(calc.sqft) ? calc.sqft : 0}</strong> sqft`;
    if (lineCuts)  lineCuts.innerHTML  = `Cutouts: <strong>${Number.isFinite(calc.cuts) ? calc.cuts : 0}</strong> × $5`;
    if (lineEdge)  lineEdge.textContent = `Edge: ${calc.edge || 'Standard'}${calc.edgeExtra ? ` (+$${calc.edgeExtra}/sqft)` : ''}`;

    const productName = $('#qm-productName')?.value || '';
    const skuVal      = $('#qm-productSKU')?.value || '';
    const prodEl = $('#qme-product', estModal); if (prodEl) prodEl.textContent = productName;
    const skuEl  = $('#qme-sku', estModal);     if (skuEl)  skuEl.textContent  = skuVal || 'N/A';

    const summaryEl = $('#qme-summary', estModal);
    if (summaryEl) {
      summaryEl.innerHTML = `This estimate is based on your inputs and current list pricing. Final amounts may vary after a precise measurement and on-site review.`;
    }
    const nextEl = $('#qme-next', estModal);
    if (nextEl) {
      nextEl.innerHTML = `A sales associate will contact you shortly to finalize your order.<br>If you have questions, please call <strong>${SUPPORT_PHONE}</strong>.`;
    }
  }

  // ========== Form validation ==========
  function validate(modal) {
    const req = {
      sqft:  $('#qm-sqft', modal),
      edge:  $('#qm-edgeType', modal),
      name:  $('#qm-name', modal),
      phone: $('#qm-phone', modal),
      email: $('#qm-email', modal),
    };
    Object.values(req).forEach(clearError);

    let firstBad = null;

    if (!isPositiveNumber(req.sqft?.value)) { setError(req.sqft, 'Please enter square feet (> 0).'); firstBad = firstBad || req.sqft; }
    if (!(req.edge?.value))                 { setError(req.edge, 'Please select an edge type.');     firstBad = firstBad || req.edge; }
    if (!req.name?.value.trim())            { setError(req.name, 'Please enter your name.');         firstBad = firstBad || req.name; }
    if (!isPhone10(req.phone?.value))       { setError(req.phone, 'Enter a valid phone number (10+ digits).'); firstBad = firstBad || req.phone; }
    if (!isEmail(req.email?.value))         { setError(req.email, 'Enter a valid email address.');   firstBad = firstBad || req.email; }

    if (firstBad) {
      firstBad.scrollIntoView({ behavior: 'smooth', block: 'center' });
      firstBad.focus?.();
      return false;
    }
    return true;
  }

  // ========== Orchestration (async so we can block on email fail) ==========
  async function computeEmailAndShow(modal) {
    const formEl = $('#qm-form', modal);
    const calc = computeEstimate(modal);

    // Build email text
    const inputsText = [
      `Square Feet: ${Number.isFinite(calc.sqft) ? calc.sqft : 'N/A'}`,
      `Cutouts: ${Number.isFinite(calc.cuts) ? calc.cuts : 0}`,
      `Edge: ${calc.edge || 'Standard'}${calc.edgeExtra ? ` (+$${calc.edgeExtra}/sqft)` : ''}`
    ].join('\n');
    const linesText = [
      `Material: $${(calc.price || 0).toFixed(2)} × ${Number.isFinite(calc.sqft) ? calc.sqft : 0} sqft = $${(calc.material || 0).toFixed(2)}`,
      `Cutouts: ${Number.isFinite(calc.cuts) ? calc.cuts : 0} × $5 = $${(calc.cutCost || 0).toFixed(2)}`,
      `Edge: ${calc.edge || 'Standard'} ${calc.edgeExtra ? `(+ $${calc.edgeExtra}/sqft × ${Number.isFinite(calc.sqft) ? calc.sqft : 0}) = $${(calc.edgeCost || 0).toFixed(2)}` : '= $0.00'}`
    ].join('\n');
    const totalText = `$${(calc.total || 0).toFixed(2)}`;

    // Send email; if fail, stay here
    showFormBanner(formEl, 'info', 'Sending your request…');
    const ok = await sendWeb3FormsEmail({
      modal,
      estimate: totalText,
      breakdown: { inputs: inputsText, lines: linesText }
    });

    if (!ok) {
      showFormBanner(formEl, 'error', 'We could not send your request right now. Please try again in about 5 minutes.');
      return; // do NOT open the estimate modal
    }

    // Success → open estimate modal
    showFormBanner(formEl, 'success', 'Request sent. Showing your estimate…');
    const est = $('#qm-estimate-modal');
    if (!est) { console.warn('[QM] estimate modal not found'); return; }
    moveToBody(est);
    wireCloseHandlers(est);
    fillEstimateModal(est, calc);

    closeModal(modal);
    openModal(est);
  }

  // --- Global close handlers (delegated; guarded) ---
  function closeAnyModal(el) {
    const modal = el.closest('.quote-modal');
    if (!modal) return;
    closeModal(modal);
  }
  function installGlobalCloseHandlers() {
    if (CLOSE_GLOBAL_WIRED) return;
    CLOSE_GLOBAL_WIRED = true;

    document.addEventListener('click', (e) => {
      const t = e.target.closest('[data-qm-close], [data-qme-close], .quote-close, .quote-backdrop');
      if (!t) return;
      e.preventDefault();
      closeAnyModal(t);
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.quote-modal.is-open').forEach(m => closeModal(m));
    });
  }

  function init() {
    installGlobalCloseHandlers(); // install once, early

    // Open modal
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-qm-open], #qm-button');
      if (!btn) return;
      e.preventDefault();

      const section = btn.closest('[data-section-id]') || document;
      const modal = $('#qm-modal', section) || $('#qm-modal');
      if (!modal) return;

      moveToBody(modal);
      wireCloseHandlers(modal);
      refreshReadOnlyFields(modal);

      // mask phone once
      wirePhoneMask($('#qm-phone', modal));

      openModal(modal);
    });

    // Submit handler
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.id !== 'qm-form') return;
      e.preventDefault();

      const modal = form.closest('#qm-modal');
      if (!modal) return;

      if (!validate(modal)) return;

      await computeEmailAndShow(modal);
    });

    // Wire close on any existing modals
    $$('#qm-modal, #qm-estimate-modal').forEach(wireCloseHandlers);

    // Debug helpers
    window.QM = {
      openForm:     () => openModal($('#qm-modal')),
      openEstimate: () => openModal($('#qm-estimate-modal')),
      compute:      () => computeEstimate($('#qm-modal')),
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init in Theme Editor
  ['shopify:section:load','shopify:section:select','shopify:section:deselect','shopify:block:select','shopify:block:deselect']
    .forEach(evt => document.addEventListener(evt, init));
})();
